import { readPersistedSessionIds } from './kronosPrefs/sessionIds';
import { readUserInstancePrefString, writeUserInstancePrefString } from './kronosPrefs/userInstancePrefs';

const INSTANCE_LAST_PRICINGLIST_PATH = 'programmations.lastPricinglistId';
const INSTANCE_LAST_BUCKETLIST_PATH = 'programmations.lastBucketlistId';

/**
 * @param {string|null|undefined} pricinglistId
 * @param {string|null|undefined} instanceId
 */
export function writeLastProgrammationPricinglistId(pricinglistId, instanceId) {
    if (pricinglistId == null || pricinglistId === '') {
        return;
    }
    const { userId, instanceId: instFromSession } = readPersistedSessionIds();
    if (!userId) {
        return;
    }
    const inst = instanceId != null ? String(instanceId) : instFromSession;
    writeUserInstancePrefString(userId, inst, INSTANCE_LAST_PRICINGLIST_PATH, String(pricinglistId));
}

/**
 * @param {string|null|undefined} [instanceId]
 * @returns {string|null}
 */
export function readLastProgrammationPricinglistId(instanceId) {
    const { userId, instanceId: instFromSession } = readPersistedSessionIds();
    if (!userId) {
        return null;
    }
    const inst = instanceId != null ? String(instanceId) : instFromSession;
    const v = readUserInstancePrefString(userId, inst, INSTANCE_LAST_PRICINGLIST_PATH);
    return v && String(v).trim() ? String(v).trim() : null;
}

/**
 * @param {string|null|undefined} bucketlistId
 * @param {string|null|undefined} instanceId
 */
export function writeLastProgrammationBucketlistId(bucketlistId, instanceId) {
    if (bucketlistId == null || bucketlistId === '') {
        return;
    }
    const { userId, instanceId: instFromSession } = readPersistedSessionIds();
    if (!userId) {
        return;
    }
    const inst = instanceId != null ? String(instanceId) : instFromSession;
    writeUserInstancePrefString(userId, inst, INSTANCE_LAST_BUCKETLIST_PATH, String(bucketlistId));
}

/**
 * @param {string|null|undefined} [instanceId]
 * @returns {string|null}
 */
export function readLastProgrammationBucketlistId(instanceId) {
    const { userId, instanceId: instFromSession } = readPersistedSessionIds();
    if (!userId) {
        return null;
    }
    const inst = instanceId != null ? String(instanceId) : instFromSession;
    const v = readUserInstancePrefString(userId, inst, INSTANCE_LAST_BUCKETLIST_PATH);
    return v && String(v).trim() ? String(v).trim() : null;
}

/**
 * @param {object|null|undefined} programmation
 * @param {string|null|undefined} instanceId
 */
export function writeLastProgrammationResourceIdsFromProgrammation(programmation, instanceId) {
    if (!programmation) {
        return;
    }
    writeLastProgrammationPricinglistId(programmation.pricinglist_id, instanceId);
    writeLastProgrammationBucketlistId(programmation.bucketlist_id, instanceId);
}

/**
 * Persist the last non-empty resource ids from a list (uses the last row).
 *
 * @param {Array<{ pricinglist_id?: string|null, bucketlist_id?: string|null }>|undefined|null} programmations
 * @param {string|null|undefined} instanceId
 */
export function rememberLastResourcesFromProgrammationsList(programmations, instanceId) {
    if (!Array.isArray(programmations) || programmations.length === 0) {
        return;
    }
    const inst = instanceId != null ? String(instanceId) : readPersistedSessionIds().instanceId;
    for (let i = programmations.length - 1; i >= 0; i--) {
        const pricinglist_id = programmations[i]?.pricinglist_id;
        if (pricinglist_id != null && pricinglist_id !== '') {
            writeLastProgrammationPricinglistId(pricinglist_id, inst);
            break;
        }
    }
    for (let i = programmations.length - 1; i >= 0; i--) {
        const bucketlist_id = programmations[i]?.bucketlist_id;
        if (bucketlist_id != null && bucketlist_id !== '') {
            writeLastProgrammationBucketlistId(bucketlist_id, inst);
            break;
        }
    }
}
